'use strict';

const _ = require('underscore');
const GroupRepository = require('common/domain/repository/group');
const ContentVersion = require('data/domain/entity/content/version');

class ContentVersionFactory {
    constructor(project) {
        this._project = project;
    }

    build(versionJSON) {
        const group = GroupRepository.getGroups().get(this._project.getGroupId());
        const members = group.getMembers({withSuspended: true});
        if(versionJSON.updatedBy) {
            const updatedBy = members.getMemberByUser(versionJSON.updatedBy);
            versionJSON.updatedBy = updatedBy
        }
        return new Promise((resolve, reject) => {
            resolve(new ContentVersion(versionJSON));
        });
    }
}

module.exports = ContentVersionFactory;


// WEBPACK FOOTER //
// ./data/domain/factory/content/version.js